import { render, staticRenderFns } from "./RowPositionDialog.vue?vue&type=template&id=0531e060&"
import script from "./RowPositionDialog.vue?vue&type=script&lang=js&"
export * from "./RowPositionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports